import React from 'react';
import {
  SelectableFilters,
  filterBySelectableItem,
  truncateAppliedFilters,
} from '../../../jobs/filterComponents/SelectableFilters';
import type { FilterComponentProps } from '../../../jobs/filterComponents/types';

export type ConnectivityStatus = 'Connected' | 'Offline' | 'Never seen';

type ConnectivityStatusFilterValues = Record<ConnectivityStatus, boolean>;

const defaultFilters: ConnectivityStatusFilterValues = { Connected: false, Offline: false, 'Never seen': false };

function renderValues(value: [string, boolean][]): string {
  return truncateAppliedFilters(value.filter(([, applied]) => applied).map(([label]) => label));
}

export const ConnectivityStatusFilters: React.FC<FilterComponentProps> = ({ columnDef, onFilterChanged }) => (
  <SelectableFilters<ConnectivityStatus, ConnectivityStatusFilterValues>
    columnDef={columnDef}
    defaultFilters={defaultFilters}
    onFilterChanged={onFilterChanged}
    options={[
      ['Connected', 'Connected'],
      ['Offline', 'Offline'],
      ['Never seen', 'Never seen'],
    ]}
    renderValues={renderValues}
  />
);

export function filterByConnectivityStatus(search: unknown, { connectivityStatus }: { connectivityStatus: string }) {
  if (connectivityStatus.startsWith('Last connected')) {
    return filterBySelectableItem<ConnectivityStatus>(search, { value: 'Offline' });
  }
  return filterBySelectableItem<ConnectivityStatus>(search, { value: connectivityStatus as ConnectivityStatus });
}
